import React, { useState } from "react";
import { useAuth } from "../../../context/authContext";
import { useChatHistory } from "../../../context/chatHistoryContext";
import Alert from "../alerts/alert";

interface FooterContentProps {
  className?: string;
}

const FooterContent: React.FC<FooterContentProps> = ({ className = "chatfooter" }) => {
  const { openChatHistory } = useChatHistory();
  const { isAuthenticated } = useAuth();
  const [alertVisible, setAlertVisible] = useState(false);

  const handleAllConversationClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (isAuthenticated) {
      openChatHistory();
    } else {
      setAlertVisible(true);
    }
  };

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="row">
              <div className="col-3">
                <span>
                  <button
                    className={`btn btn-link small ${!isAuthenticated ? "disabled" : ""}`}
                    onClick={(e) => handleAllConversationClick(e)}
                    style={{
                      textDecoration: "none",
                      color: "rgb(27, 72, 126)",
                      fontSize: "12px",
                      fontWeight: 300
                    }}
                  >
                    <i className="bi bi-chat-right-dots"></i> All Conversation
                  </button>
                </span>
              </div>
              <div className="col-3">
                <span>
                  <a className="small" href="/terms-and-conditions">
                    Terms and Conditions
                  </a>
                </span>
              </div>
              <div className="col-3" style={{ textAlign: "center" }}>
                <span>
                  <a className="small" href="/privacy-policy">
                    Privacy Policy
                  </a>
                </span>
              </div>
              <div className="col-3" style={{ textAlign: "center" }}>
                <span>
                  <a className="small" href="/schedule-consultant">
                    Schedule Advisor Discussion
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Alert
        message="Loads only when logged in."
        type="warning"
        show={alertVisible}
        onClose={() => setAlertVisible(false)}
      />
    </>
  );
};

export default FooterContent; 